import { defineMessages } from 'react-intl';

export default defineMessages({
    businessClass: {
        id: 'ml.quoteandbind.hobusscheditems.businessClass',
        defaultMessage: 'Business Class'
    },
    businessSubClass: {
        id: 'ml.quoteandbind.hobusscheditems.businessSubClass',
        defaultMessage: 'Business Sub Class'
    },
    action: {
        id: 'ml.quoteandbind.hobusscheditems.action',
        defaultMessage: 'Action'
    },
    addBtn: {
        id: 'ml.quoteandbind.hobusscheditems.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.hobusscheditems.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.hobusscheditems.remove',
        defaultMessage: 'Remove'
    }
});
